// components/configurations/CodeConfiguration.tsx
import React from 'react';
import { ColorField } from 'components/fields/ColorField/ColorField';
import { RadioField } from 'components/fields/RadioField/RadioField';
import ExpandableSection from 'components/ExpandableSection/ExpandableSection';
import SizeField from '../../SizeField/SizeField';

interface CodeConfigurationProps {
    localConfig: any;
    selectedTab: string;
    handleChange: (field: string, value: any) => void;
    getFieldValues: (field: string) => any;
}

const CodeConfiguration: React.FC<CodeConfigurationProps> = ({
    localConfig,
    selectedTab,
    handleChange,
    getFieldValues
}) => {
    return (
        <>
            {/* Aquí irá la configuración específica del componente Code */}
        </>
    );
};

export default CodeConfiguration;
